module.exports = __webpack_public_path__ + "assets/img/img154.d513a6af.png";